import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Card, Table, Button } from 'reactstrap';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import moment from 'moment';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};

class ExamResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateDocument: new Date(),
            descriptionDocument: "",
            dateExam: new Date(),
            descriptionExam: "",
            analisys: "",
            file: null,
            errors: {},
        }
    }

    handlerDateDocument = (dateDocument) => {
        this.setState({ dateDocument: dateDocument });
    }

    handlerDescriptionDocument = (descriptionDocument) => {
        this.setState({ descriptionDocument: descriptionDocument })
    }

    handlerDateExam = (dateExam) => {
        this.setState({ dateExam: dateExam });
    }

    handlerDescriptionExam = (descriptionExam) => {
        this.setState({ descriptionExam: descriptionExam })
    }

    handlerAnalisys = (analisys) => {
        this.setState({ analisys: analisys });
    }

    validate = () => {
        var errors = {};
        var error = false;
        if (this.state.descriptionDocument === "") {
            errors.descriptionDocument = "Ingrese una descripción al archivo";
            error = true;
        } else {
            errors.descriptionDocument = "";
        }

        if (this.state.file == null) {
            errors.file = "Seleccione un archivo";
            error = true;
        } else {
            errors.file = "";
        }

        this.setState({ errors: errors });
        return error;
    }

    uploadFile = () => {
        if (!this.validate()) {
            //console.log(this.state.file);

            var dataFile = new FormData();
            dataFile.append("archivo", this.state.file);
            dataFile.append("id_historia", parseInt(this.props.id_historia));
            dataFile.append("id_admision", parseInt(this.props.id_admision));
            dataFile.append("descripcion", this.state.descriptionDocument);
            dataFile.append("clase", "Examen de Laboratorio");
            dataFile.append("fecha", moment(this.state.dateDocument).format("YYYY/MM/DD"));
            dataFile.append("hora", moment(this.state.dateDocument).format("HH:MM A"));

            fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/create', {
                method: 'POST',
                headers: {
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: dataFile
            })
                .then(response => {
                    return response.text();
                })
                .then(data => {
                    console.log(data);
                    alert("archivo Subido Correctamente");
                });
        }else {
            console.log(this.state.errors);
        }
    }

    render() {

        return (
            <Col>
                <Card body outline color="secondary">
                    <div className="card__title">
                        <h5 className="bold-text">Adjuntar Examenes de Laboratorio</h5>
                    </div>
                    <div className="form" style={{ display: "flex", flexDirection: "column" }}>
                        <div style={{ display: 'flex', marginTop: 50, }}>
                            <div className="form__form-group" >
                                <div className="form__form-group-field" >
                                    <div style={{ marginRight: 20, }} >
                                        <span className="form__form-group-label" style={{ marginTop: 10 }}>Fecha del Documento </span>
                                    </div>
                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                        <DatePicker
                                            views={["year", "month", "date"]}
                                            value={this.state.dateDocument}
                                            className="material-form__field"
                                            style={{ width: 150, marginLeft: 20 }}
                                            onChange={(date) => {
                                                this.handlerDateDocument(date);
                                            }}
                                            animateYearScrolling
                                            format="yyyy/MM/D"
                                        />
                                    </MuiPickersUtilsProvider>
                                    <span className="form__form-group-label" style={{ marginLeft: 20, marginTop: 10 }}> Descripción</span>
                                    <input
                                        name="product-text"
                                        component={renderField}
                                        type="text"
                                        style={{ width: '15%', marginLeft: 20 }}
                                        onChange={(e) => {
                                            this.handlerDescriptionDocument(e.target.value);
                                        }}
                                    />
                                    <input
                                        type="file"
                                        style={{ width: '15%', marginLeft: 20 }}
                                        onChange={(e) => {
                                            console.log(e.target.files[0]);
                                            this.setState({ file: e.target.files[0] });
                                        }}
                                    />
                                    <Button style={{ marginLeft: 50, }} size="sm"
                                        onClick={() => {
                                            this.uploadFile();
                                            
                                        }}
                                    >Confirmar Documento</Button>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', marginTop: 50, }}>
                            <div className="form__form-group" >
                                <div className="form__form-group-field" >
                                    <div style={{ marginRight: 20, }} >
                                        <span className="form__form-group-label" style={{ marginTop: 10 }}>Fecha Examen </span>
                                    </div>
                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                        <DatePicker
                                            views={["year", "month", "date"]}
                                            className="material-form__field"
                                            style={{ width: 150, marginLeft: 20 }}
                                            value={this.state.dateExam}
                                            onChange={(date) => {
                                                this.handlerDateExam(date);
                                            }}
                                            animateYearScrolling
                                            format="yyyy/MM/D"
                                        />
                                    </MuiPickersUtilsProvider>
                                    <span className="form__form-group-label" style={{ marginLeft: 20, marginTop: 10 }}> Descripción</span>
                                    <Field
                                        name="textarea-description"
                                        component="textarea"
                                        type="text"
                                        style={{ width: '60%', marginLeft: 20 }}
                                        onChange={(e) => {
                                        }}
                                    />
                                    <span className="form__form-group-label" style={{ marginLeft: 20, marginTop: 10 }}> Analisis</span>
                                    <Field
                                        name="textarea-analisys"
                                        component="textarea"
                                        type="text"
                                        style={{ width: '60%', marginLeft: 20 }}
                                        onChange={(e) => {
                                            //this.handlerCorrcteActions(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Table bordered style={{ width: '80%', marginTop: 20, marginLeft: 50 }}>
                        <thead>
                            <tr>
                                <td>Id </td>
                                <td >Fecha Documento </td>
                                <td >Fecha Registro </td>
                                <td >Descripción</td>
                                <td >Nombre</td>
                                <td >Tipo</td>
                                <td >Usuario</td>
                                <td >Revisado</td>
                            </tr>
                        </thead>
                    </Table>
                    
                </Card>
            </Col>
        );
    }

}

export default reduxForm({
    form: `exam-form`, // a unique identifier for this form
})(withTranslation('common')(ExamResult));